const subdomains = [
  'amityage',
  'cryptohall24-quetta',
  'cryptohall24-duerr',
  'qurubiqa',
  'bitcluster',
  'paymine',
  'dahab',
  'bmw',
  'stellar-forge',
  'pantheon',
  'pantheon-aus',
  'avatron',
  'polarcore',
  'endlessmining',
  'sabre56',
  'chronos-energy',
  'higgs',
  'mawson',
  'revolve-labs',
  'hearst',
  'datacubes',
  'bitasics',
  'emcd',
  'blueforge',
  'cryptotech',
  'miningstore',
  'hashlabs',
  'corpa',
  'terahash',
  'fortris',
  'ymir',
  'chazon',
  'miningwithbrad'
];

const extractSubdomain = () => {
  const hostnameParts = window.location.hostname.split('.');

  const matchedSubdomain = hostnameParts.find(part =>
    subdomains.includes(part)
  );

  return {
    matchedSubdomain,
    hostnameParts
  };
};

export const getThemeKey = () => {
  const { matchedSubdomain } = extractSubdomain();

  return {
    themeKey: matchedSubdomain ?? 'duckenergy'
  };
};

export const getDomainAndSubdomain = () => {
  const { matchedSubdomain, hostnameParts } = extractSubdomain();

  const domainParts = hostnameParts.filter(p => p !== matchedSubdomain);
  const domain = domainParts.join('.');

  return {
    subdomain: matchedSubdomain ?? 'my',
    domain
  };
};
